import { useState, useEffect } from 'react';
import {
  DashboardOutlined,
  DownloadOutlined,
  MailFilled,
  MailOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  PicRightOutlined,
  SecurityScanOutlined,
  UserOutlined,
  LogoutOutlined,
  ExclamationCircleOutlined,
  DeleteOutlined,
  SettingFilled,
  SafetyOutlined,
  SolutionOutlined,
  GlobalOutlined,
  ProfileFilled

} from '@ant-design/icons';
import { Button, Layout, Menu, App, Input } from 'antd';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import Logo1 from "../assests/Culsight Logo - Negative (1).png";
import Logo2 from "../assests/Culsight Logo (1) (1).png";
import { getUser, logout } from '../../authService';
import UserDropdown from '../components/UserDropdown';
import ThemeSetting from '../../Admin-panel/components/ThemeSetting';

const { Header, Sider, Content } = Layout;

const MasterTemplate = () => {
  const { modal } = App.useApp()

  const [user, setUser] = useState(null);
  const [master_loder, set_master_loder] = useState(true);
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [openKeys, setOpenKeys] = useState([]);
  const [balck_theme, set_balck_theme] = useState(false);
  useEffect(() => {
    // Sync function jo local storage se user state update karegi
    const syncUser = () => {
      const localUser = localStorage.getItem("user");
      if (localUser) {
        setUser(JSON.parse(localUser));
      }
    };

    // Listen for our custom event
    window.addEventListener("storage_updated", syncUser);

    // Initial load logic jo aapka pehle se tha
    const localUser = localStorage.getItem("user");
    if (localUser) {
      setUser(JSON.parse(localUser));
      set_master_loder(false);
    } else {
      getUser().then(usr => {
        setUser(usr);
        set_master_loder(false);
        localStorage.setItem("user", JSON.stringify(usr));
      });
    }

    // Cleanup
    return () => window.removeEventListener("storage_updated", syncUser);
  }, []);

  useEffect(() => {

    const pathToKey = {
      '/': { selected: '1' },
      '/smtp': { selected: '2', open: '2' },
      '/add-smtp': { selected: '2', open: '2' },
      '/edit-smtp': { selected: '2', open: '2' },
      '/users': { selected: '4', open: '3' },
      '/users-camp': { selected: '4', open: '3' },
      '/add-user': { selected: '3', open: '3' },
      '/edit-user': { selected: '3', open: '3' },
      '/imported-users': { selected: '5', open: '3' },
      '/user-group': { selected: '6', open: '6' },
      '/assign-user': { selected: '6', open: '6' },
      '/learners-group': { selected: '7', open: '7' },
      '/assign-learner': { selected: '7', open: '7' },
      '/email-template': { selected: '8', open: '8' },
      '/add-email': { selected: '8', open: '8' },
      '/landing-page': { selected: '9', open: '9' },
      '/add-landingpage': { selected: '9', open: '9' },
      '/edit-landingpage': { selected: '9', open: '9' },
      '/campaign': { selected: '10', open: '10' },
      '/add-campaign': { selected: '10', open: '10' },
      '/view-campaign': { selected: '10', open: '10' },
      '/offender': { selected: '12', open: '12' },
      '/offender-camp-details': { selected: '12', open: '12' },
      '/downloads': { selected: '11', open: '11' },
      '/tool-setting': { selected: '50', open: '50' },
      '/deleted-report': { selected: '13', open: '13' },
      '/deleted-camaign': { selected: '13', open: '13' },
      '/deleted-offender': { selected: '13', open: '13' },
      '/setting': { selected: '14', open: '14' },
      '/department-heatmap': { selected: '15', open: '15' },
      '/human-risk-scorecard': { selected: '16', open: '16' },
      '/media': { selected: '18' },
    };
    const path = location.pathname;
    const match = pathToKey[path];
    if (match) {
      setSelectedKeys([match.selected]);
      if (match.open) {
        setOpenKeys([match.open]);
      } else {
        setOpenKeys([]);
      }
    }
    set_balck_theme(0);
  }, [location.pathname]);


  const handleMenuClick = ({ key }) => {
    const keyToPath = {
      '1': '/',
      '2': '/smtp',
      '4': '/users',
      '5': '/imported-users',
      '6': '/user-group',
      '7': '/learners-group',
      '8': '/email-template',
      '9': '/landing-page',
      '10': '/campaign',
      '12': '/offender',
      '11': '/downloads',
      '50': '/tool-setting',
      '13': '/deleted-report',
      '14': '/setting',
      '15': '/department-heatmap',
      '16': '/human-risk-scorecard',
      '18': '/media',
    };

    const route = keyToPath[key];
    if (route) {
      clearPageStorage(route);
      navigate(route);
    } else if (key === '51') {
      modal.confirm({
        title: "Are you sure you want to logout?",
        okText: "Logout",
        cancelText: "Cancel",
        onOk: () => {
          clearPageStorage("");
          localStorage.removeItem("user");
          logout();
        },
      });
    }
  };

  const onOpenChange = (keys) => {
    setOpenKeys(keys);
  };

  if (!user) {
    return <Navigate path="/" />
  }


  const clearPageStorage = (currentRoute) => {
    const pageStorageKeys = {
      "/campaign": [
        "campaign_search_type",
        "campaign_search",
        "campaign_last_search_page",
        "campaign_page",
        "campaign_page_size",
      ],

      "/smtp": [
        "smtp_last_search_page",
        "smtp_search",
        "smtp_page",
      ],


      "/users": [
        "user_last_search_page",
        "user_search",
        "user_search_key",
        "user_page",

      ],

      "/imported-users": [
        "imported_users_page",

      ],

      "/user-group": [
        "user_group_last_search_page",
        "user_group_search",
        "user_group_page",
        "user_group_page_size",
      ],

      "/email-template": [
        "email_last_search_page",
        "email_search",
        "email_page",
      ],

      "/landing-page": [
        "landing_last_search_page",
        "landing_search",
        "landing_page",
      ],

      "/offender": [
        "offender_last_search_page",
        "offender_search",
        "offender_search_key",
        "offender_page",
      ],

      "/downloads": [
        "campaign_download_last_search_page",
        "campaign_download_search",
        "campaign_download_page",
        "offender_download_last_search_page",
        "offender_download_search",
        "offender_download_page",
        "offender_download_search_key",
      ],






    };

    Object.entries(pageStorageKeys).forEach(([route, keys]) => {
      if (route !== currentRoute) {
        keys.forEach((key) => localStorage.removeItem(key));
      }
    });
  };

  return (
    <>
      {master_loder ? <>
        Loading...........
      </> : <>
        <Layout style={{ minHeight: '100vh' }}>
          <Sider trigger={null} collapsible collapsed={collapsed} width={230} collapsedWidth={80} style={balck_theme ? { background: "#141414" } : { background: "#fff" }}>
            <div className='menu-logo'>
              <img
                alt="logo"
                src={balck_theme ? Logo1 : Logo2}
              />
            </div>

            <Menu
              // theme="dark"
              mode="inline"
              selectedKeys={selectedKeys}
              openKeys={openKeys}
              onOpenChange={onOpenChange}
              onClick={handleMenuClick}
              items={[
                {
                  key: '1',
                  icon: <DashboardOutlined />,
                  label: 'Dashboard',
                },
                {
                  key: '10',
                  icon: <GlobalOutlined />,
                  label: 'Campaign',
                },
                {
                  key: '2',
                  icon: <MailFilled />,
                  label: 'SMTP',
                },
                {
                  key: '3',
                  icon: <UserOutlined />,
                  label: 'Users',
                  children: [
                    { key: '4', label: "Users" },
                    { key: '5', label: "Imported Users" }
                  ]
                },
                {
                  key: '6',
                  icon: <UserOutlined />,
                  label: 'Users Group',
                },
                {
                  key: '7',
                  icon: <UserOutlined />,
                  label: 'Learners Group',
                },
                {
                  key: '8',
                  icon: <MailOutlined />,
                  label: 'Email Template',
                },
                {
                  key: '9',
                  icon: <PicRightOutlined />,
                  label: 'Landing Page',
                },
                // {
                //   key: '18',
                //   icon: <ProfileFilled />,
                //   label: 'Media',
                // },

                {
                  key: '12',
                  icon: <ExclamationCircleOutlined />,
                  label: 'Offender',
                },
                {
                  key: 'group',
                  label: 'ANALYTICS',
                  type: 'group',
                  children: [
                    { key: '15', icon: <SafetyOutlined />, label: "Department Heatmap", title: "View department-wise risk heatmap" },
                    { key: '16', icon: <SolutionOutlined />, label: "Human Risk Scorecard", title: "View detailed risk scorecards for individuals" },

                  ]
                },

                {
                  key: 'group_reports',
                  label: 'REPORTS',
                  type: 'group',
                  children: [
                    {
                      key: '11',
                      icon: <DownloadOutlined />,
                      label: 'Downloads',
                    },
                  ],
                },

                // {
                //   key: '13',
                //   icon: <DeleteOutlined />,
                //   label: 'Deleted Report',
                // },
                {
                  key: 'group_system',
                  label: 'SYSTEM',
                  type: 'group',
                  children: [
                    {
                      key: '50',
                      icon: <SecurityScanOutlined />,
                      label: 'Tool Setting',
                    },
                  ],
                },




                //     {
                //   key: 'group',
                //   label: 'SYSTEM',
                //   type: 'group',
                //   children: [
                //     { key: '14',icon: <SettingFilled />, label: "Setting" },

                //   ]
                // },
                {
                  key: 'divider_logout',
                  disabled: true,
                  style: {
                    height: 1,
                    margin: '8px 0',
                    boxShadow: '0 3px 6px rgba(0,0,0,0.12)',
                  },
                  label: null,
                },
                {
                  key: '51',
                  icon: <LogoutOutlined />,
                  label: 'Logout',
                },

              ]}
            />
          </Sider>
          <Layout>
            <Header
              style={
                balck_theme
                  ? {
                    padding: "0 10px",
                    backgroundColor: "#141414",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    color: "#fff",
                  }
                  : {
                    padding: "0 10px",
                    backgroundColor: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    color: "#141414",
                  }
              }
            ><div>
                <Button
                  type="text"
                  icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                  onClick={() => setCollapsed(!collapsed)}
                  style={{
                    fontSize: '16px',
                    width: 64,
                    height: 64,
                    color: balck_theme ? "#fff" : "#141414",
                  }}
                />
                <span style={{ fontWeight: "bold", fontSize: "20px" }}>Phishing Tool</span>
              </div>
              <div style={{ gap: "20px", display: "flex" }}>
                {/* <ThemeSetting set_theme_style={set_balck_theme} /> */}
                {/* <Input.Search
                size='large'
                  placeholder="Search..."
                  onSearch={(value) => console.log(value)}
                  style={{ width: 250 }}
                /> */}
                <UserDropdown user={user} />
              </div>

            </Header>
            <Content style={
              balck_theme
                ? { backgroundColor: "#000000" }
                : { backgroundColor: "#f4f4f4" }
            }>
              <Outlet />
            </Content>
          </Layout>
        </Layout>
      </>}
    </>
  );
};

export default MasterTemplate;
